import React, {CSSProperties, MouseEventHandler} from "react";
import classNames from "classnames";

import type {MaterialSymbol} from 'material-symbols';
import type {IconSize} from "./index";


import './icon.css';


export interface MuiIconProps extends React.HTMLAttributes<HTMLElement> {
    children?: any;
    code?: MaterialSymbol;
    size?: IconSize;
    onClick?: MouseEventHandler;
    className?: string;
    style?: CSSProperties;
    colorOverwritten?: boolean;
    fullHeight?: boolean;
    isFilled?: boolean;
    additionalPadding?: number;
    additionalPaddingInlineEnd?: number;
    mouseEnter?: MouseEventHandler;
    mouseLeave?: MouseEventHandler;
    type?:'primary' | 'accent' | 'success' | 'neutral' | 'danger';
}

export type MuiIconExternalProps = Omit<MuiIconProps, 'code'>;

export const MuiIcon = React.forwardRef<HTMLElement, MuiIconProps>(
    ({
         size = 24,
         onClick,
         className,
         colorOverwritten = false,
         fullHeight = false,
         isFilled = false,
         code,
         children,
         additionalPadding,
         additionalPaddingInlineEnd,
        type,
         ...restProps
     }: MuiIconProps,
     ref
    ) => {

        let style: CSSProperties | undefined = undefined;
        if (additionalPadding) {
            style = {padding: `${additionalPadding}px`};
        }
        if (additionalPaddingInlineEnd) {
            if (additionalPadding) {
                style = {padding: `${additionalPadding}px ${additionalPaddingInlineEnd}px ${additionalPadding}px ${additionalPadding}px`};
            } else {
                style = {paddingInlineEnd: `${additionalPaddingInlineEnd}px`};
            }
        }

        return (
            <span
                ref={ref}
                className={classNames({
                    [`icon`]: true,
                    [`${className}`]: !!className,
                    [`icon--clickable`]: !!onClick,
                    [`icon--inherit-color`]: !colorOverwritten,
                    [`icon--fullHeight`]: fullHeight,
                })}
                onClick={onClick}
                style={style}
                {...restProps}
            ><span className={classNames({
                'material-symbols-rounded': true,
                [`icon--${size}`]: !!size,
                [`icon--${type}`]: type,
                [`icon--filled`]: isFilled,
            })}>{code ? code : children}</span></span>
        );
    })
